let config = {
    appVersion: "0.5.9"
}

export default config